import React, { useEffect, useRef, useState } from "react";

function PulseCell({
  value,
  formatter = (v) => v,
  className = "",
}) {
  const previousValue = useRef(value);
  const [animation, setAnimation] = useState("");

  useEffect(() => {
    if (previousValue.current === value) return;

    setAnimation(
      value > previousValue.current
        ? "price-up"
        : "price-down"
    );

    previousValue.current = value;

    const timer = setTimeout(() => {
      setAnimation("");
    }, 3000);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <span className={`${className} ${animation}`}>
      {formatter(value)}
    </span>
  );
}

export default React.memo(PulseCell);